
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Chart from "chart.js"
import { Line, Bar, mixins } from "vue-chartjs"

@Component
export default class BarChartComponent extends Mixins(Line, Bar, mixins.reactiveProp) {
  @Prop()
  /*chartData!: Chart.ChartData*/
  declare chartData: Chart.ChartData

  @Prop()
  /*chartOptions!: Chart.ChartOptions*/
  declare chartOptions: Chart.ChartOptions

  mounted () {
    /* グラフ描画  */
    this.renderChart(this.chartData, this.chartOptions)
  }
}
